(function () {
    'use strict';
    angular
        .module('app')
        .controller('editEmails', editEmails);
    editEmails.$inject = ['$location', '$scope', '$rootScope', '$timeout', 'editEmailsService', '$mdDialog', 'loginService']; // 'gridDataService', '$q', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService'
    function editEmails($location, scope, $rootScope, $timeout, editEmailsService, $mdDialog, loginService) { // gridDataService, $q, $timeout, $mdDialog, records, command, commandService, loginService

        scope.loginService = loginService;

        scope.editEmailsDialogShown = false;
        scope.xyz = { bEnableEdit: false, bEnableRemove: false, bEnableOK: true, selectedUserItem: {}, processing: false};
        scope.$on('editEmailsTriggered', function (event, arg) {
            scope.onEditEmailsTriggered(arg.slx);
        });

        //
        // On user change.
        //
        scope.selectedUserChanged = function () {
            // Do Enables.
            scope.doEnables();
        };

        //
        // Enables.
        //
        scope.doEnables = function () {
            var selCount = scope.gridApi.selection.getSelectedRows().length;
            if (selCount != 1) {
                scope.xyz.bEnableEdit = false;
            }
            else {
                scope.xyz.bEnableEdit = true;
            }
            if(selCount < 1)
            {
                scope.xyz.bEnableRemove = false;
            }
            else {
                scope.xyz.bEnableRemove = true;
            }
            var count = scope.gridOptions.data.length;
            if (count < 1)
                scope.xyz.bEnableOK = false;
            else
                scope.xyz.bEnableOK = true;
        }

        var selectDefaultItem = function () {
            setTimeout(function () {
                var bSelectedSomething = false;
                if (scope.gridApi.selection.getSelectedRows().length < 1) {
                    if (scope.gridOptions.data.length > 0) {
                        bSelectedSomething = true;
                        scope.gridApi.selection.selectRow(scope.gridOptions.data[0]);
                    }
                }
                if (!bSelectedSomething)
                    scope.doEnables(); // need to call manually because we didn't select anything.
            }, 50);
            // Do Enables.
            //scope.doEnables();
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {
            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });
            // Get the selected items.
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
            });

            // Do Enables.
            scope.doEnables();
        };

        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // On Show
        scope.onEditEmailsTriggered = function (slx) {

            //scope.testLabel = editEmailsService.incoming;
            scope.emails = editEmailsService.incoming;

            // scope
            //scope.slx = slx;
            scope.xyz = { bEnableEdit: false, bEnableRemove: false, bEnableOK: true, selectedUserItem: {} };

            //defect id: 23879 - updated resource strings to EMAIL_
            var colNameTo = loginService.resourceStrings["EMAIL_TO"]; // "To";
            var colNameSubject = loginService.resourceStrings["EMAIL_SUBJECT"]; // "Subject";
            var colNameBody = loginService.resourceStrings["EMAIL_BODY"]; // "Body";

            scope.gridOptions.columnDefs = [{ name: colNameTo, field: 'toCol', width: '33%', minWidth: '100' },
                { name: colNameSubject, field: 'subjectCol', width: '33%', minWidth: '100' },
                { name: colNameBody, field: 'bodyCol', width: '33%', minWidth: '100' }];

            // dialog config
            scope.heading = loginService.resourceStrings["EDIT_EMAILS"]; // "Edit Emails"
            scope.emailsLabel = loginService.resourceStrings["EMAILS_TO_BE_SENT"]; // "Emails to be sent"
            scope.Edit = loginService.resourceStrings["EDIT"]; // "Edit"
            scope.Remove = loginService.resourceStrings["REMOVE"]; // Remove
            scope.OK = loginService.resourceStrings["OK"]; // "OK"
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel"


            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.emails, function (item) {
                var sTo = editEmailsService.umToDisplay(item.toUserModels);
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    emailItem: item,
                    isSelected: false,
                    toCol: sTo, subjectCol: item.subject, bodyCol: item.body
                });
                index++;
            });

            // Select 1 item.
            selectDefaultItem();
            // Do modal.
            scope.editEmailsDialogShown = true;
        };

        scope.doColumns = function () {
            //// dialog config columns
            //var colTo = loginService.resourceStrings["TO"];
            //var colSubject = loginService.resourceStrings["SUBJECT"];
            //var colBody = loginService.resourceStrings["BODY"];
            //scope.gridOptions.columnDefs[0].name = colTo;
            //scope.gridOptions.columnDefs[1].name = colSubject;
            //scope.gridOptions.columnDefs[2].name = colBody;
        }

        scope.onEdit = function () {
            var item = scope.gridApi.selection.getSelectedRows()[0];
            editEmailsService.editEmail = item;
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/editEmails/templates/editEmail.html',
                controller: 'editEmail',
                fullscreen: false,
                locals: {
                },
                skipHide: true
            });
        }

        // Callback from the input box after the box has closed.
        var editEmailsRemoveConfirmPostCloseCallback = function (param1, param2, bOK) {
            if (bOK) {
                angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                    scope.gridOptions.data.splice(scope.gridOptions.data.lastIndexOf(item), 1);
                });
                selectDefaultItem();
            }
        }

        scope.onRemove = function () {
            var msg = loginService.resourceStrings["REMOVE_EMAILS_CONFIRM"]; // "Removed emails will not be sent. Continue?"
            //var bContinue = confirm(msg);
            //if (!bContinue)
            //    return;
            $rootScope.confirmBoxShow("", "", "", msg, "", editEmailsRemoveConfirmPostCloseCallback);
        }

        scope.onEditEmailsDialogOK = function () {
            scope.xyz.processing = true;

            // Pull from columns to a var.
            scope.emailsToSend = [];
            angular.forEach(scope.gridOptions.data, function (item) {
                var emailItem = item.emailItem;
                //emailItem.to = item.to;
                //emailItem.subject = item.subject;
                //emailItem.body = item.body;
                //emailItem.toUserModels = item.toUserModels;
                scope.emailsToSend.push(emailItem);
            });

            if (scope.emailsToSend.length < 1)
            {
                $mdDialog.hide();
                scope.xyz.processing = false;
                return;
            }
            // Execute.
            editEmailsService.sendEmails(scope.emailsToSend).then(function (response) {
                // Close dialog.
                $mdDialog.hide();
                scope.xyz.processing = false;
            }, function () {
                scope.xyz.processing = false;
            });
        };

        scope.onEditEmailsDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.editEmailsDialogClosed = function () {

        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            //after the grid has been initialized
            scope.onEditEmailsTriggered();
        }

        scope.gridApi = {};

        var colNameTo = loginService.resourceStrings["TO"]; // "To";
        var colNameSubject = loginService.resourceStrings["SUBJECT"]; // "Subject";
        var colNameBody = loginService.resourceStrings["BODY"]; // "Body";

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: colNameTo, field: 'toCol', width: '33%', minWidth: '100' },
                { name: colNameSubject, field: 'subjectCol', width: '33%', minWidth: '100' },
                { name: colNameBody, field: 'bodyCol', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
